<template>
  <div class="card card-custom gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Trocar Senha
        </span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          Altere a sua senha de acesso
        </span>
      </h3>
      <div class="card-toolbar"></div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body pt-2 pb-0">
      <b-form style="margin-bottom: 20px;">
        <b-form-group label="Senha atual:">
          <b-form-input
            type="password"
            v-model="senhaAtual"
            placeholder="Senha atual"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Nova senha:">
          <b-form-input
            type="password"
            v-model="novaSenha"
            placeholder="Nova senha"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Confirme a nova senha:">
          <b-form-input
            type="password"
            v-model="confirmeNovaSenha"
            placeholder="Confirme a nova senha"
          ></b-form-input>
        </b-form-group>

        <b-button
          class="margin-btn-5"
          @click="salvar"
          variant="primary"
          :disabled="
            !senhaAtual || !novaSenha || !confirmeNovaSenha || carregando
          "
        >
          <b-spinner
            v-if="carregando"
            small
            style="margin-bottom: 2px; margin-right: 3px;"
          ></b-spinner>
          Salvar
        </b-button>

        <b-button
          class="margin-btn-5"
          @click="voltar"
          variant="danger"
          :disabled="carregando"
        >
          <b-spinner
            v-if="carregando"
            small
            style="margin-bottom: 2px; margin-right: 3px;"
          ></b-spinner>
          Voltar
        </b-button>
      </b-form>
    </div>
    <!--end::Body-->
  </div>
</template>

<style lang="scss" scoped>
.margin-btn-5 {
  margin-right: 5px;
}
</style>

<script>
import { mapActions } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";

export default {
  name: "TrocaSenha",
  data() {
    return {
      senhaAtual: "",
      novaSenha: "",
      confirmeNovaSenha: "",
      carregando: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Trocar Senha" }]);
  },
  methods: {
    ...mapActions(["updateAlterarSenhaUsuario"]),
    validarSenha() {
      let msg = "";

      var regExpNumeros = /\d/g;
      var regExpMinorLetters = /[a-z]/g;
      var regExpMajorLetters = /[A-Z]/g;

      if (this.novaSenha.length < 8) {
        msg = "A nova senha precisa ter no mínimo 8 dígitos.";
      } else if (!regExpNumeros.test(this.novaSenha)) {
        msg = "A nova senha precisa ter no mínimo um número.";
      } else if (!regExpMinorLetters.test(this.novaSenha)) {
        msg = "A nova senha precisa ter no mínimo uma letra minúscula.";
      } else if (!regExpMajorLetters.test(this.novaSenha)) {
        msg = "A nova senha precisa ter no mínimo uma letra maiúscula.";
      } else if (this.novaSenha !== this.confirmeNovaSenha) {
        msg = "A nova senha precisa ser igual a confirmação da senha.";
      }

      return msg;
    },
    async salvar() {
      let msg = this.validarSenha();

      if (msg) {
        Swal.fire({
          title: "",
          text: msg,
          icon: "warning",
          showConfirmButton: false,
          timer: 3000
        });
      } else {
        this.carregando = true;

        let resultado = await this.updateAlterarSenhaUsuario({
          senhaAtual: this.senhaAtual,
          novaSenha: this.novaSenha
        });

        this.carregando = false;

        if (resultado.resultado) {
          Swal.fire({
            title: "",
            text: "A sua senha foi alterada com sucesso.",
            icon: "success",
            showConfirmButton: false,
            timer: 3000
          });

          this.$router.push("/dashboard");
        } else {
          this.senhaAtual = "";

          Swal.fire({
            title: "",
            text: resultado.msg,
            icon: "warning",
            showConfirmButton: false,
            timer: 3000
          });
        }
      }
    },
    voltar() {
      this.$router.push("/dashboard");
    }
  }
};
</script>
